import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import StarRating from "@/components/StarRating";
import { TYPE_LABELS } from "@/lib/constants";

export default function PrinterCard({ printer, priority = false }) {
    return (
        <Link
            to={`/reviews/${printer.slug}`}
            data-testid={`printer-card-${printer.slug}`}
            className="group card-flat overflow-hidden flex flex-col hover:border-zinc-600 transition-colors duration-200"
        >
            <div className="relative aspect-[4/3] overflow-hidden bg-zinc-900">
                <img
                    src={printer.image}
                    alt={printer.name}
                    loading={priority ? "eager" : "lazy"}
                    className="w-full h-full object-cover transition-transform duration-500 ease-out group-hover:scale-105"
                />
                <div className="absolute top-3 left-3 flex gap-2">
                    <span className="bg-zinc-950/85 backdrop-blur-sm text-[10px] tracking-[0.18em] uppercase text-zinc-300 px-2 py-1 border border-zinc-800">
                        {printer.brand}
                    </span>
                    <span className="bg-blue-600/95 backdrop-blur-sm text-[10px] tracking-[0.18em] uppercase text-white px-2 py-1">
                        {TYPE_LABELS[printer.type] || printer.type}
                    </span>
                </div>
            </div>
            <div className="p-5 md:p-6 flex flex-col gap-3 flex-1">
                <h3 className="font-display font-semibold text-lg md:text-xl text-white tracking-tight group-hover:text-blue-400 transition-colors duration-200">
                    {printer.name}
                </h3>
                <p className="text-sm text-zinc-400 leading-relaxed line-clamp-2">{printer.tagline}</p>
                <div className="mt-auto flex items-end justify-between pt-3 border-t border-zinc-900">
                    <StarRating value={printer.rating} size="sm" />
                    <div className="text-right">
                        <div className="text-[10px] tracking-[0.2em] uppercase text-zinc-500">MSRP</div>
                        <div className="font-mono text-sm text-white">${printer.price_usd.toFixed(0)}</div>
                    </div>
                </div>
                <div className="inline-flex items-center gap-1 text-xs text-blue-400 font-medium">
                    Read review <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </div>
            </div>
        </Link>
    );
}
